// extracted by mini-css-extract-plugin
module.exports = {"item":"item--jswTD"};